import { useEffect, useMemo, useState } from 'react';
import { Tabs } from '@pmi/dsm-react';
import {
  BundleReportItem,
  ProductReport,
} from '../../../../shared/models/ReportModel';
import BreakdownTable from './BreakdownTable';
import styles from '../productDetailsReport.module.scss';
import { getBundleItems, getStatusCounts, getTypeLabel } from '../../services';

export default function StatusBreakdown({
  product,
  scrollToTable,
  onBundleProductTabChange,
  selectedProductTypeTab,
}: {
  product: ProductReport;
  scrollToTable: (value: string) => void;
  onBundleProductTabChange: (sku: string) => void;
  selectedProductTypeTab: string;
}) {
  if (!selectedProductTypeTab) return null;

  const items: BundleReportItem[] = product.bundle
    ? getBundleItems(product)
    : [product];

  const [selectedItem, setSelectedItem] = useState(
    selectedProductTypeTab
      ? items.find((e) => e.sku === selectedProductTypeTab)
      : items[0],
  );

  const statusCount = useMemo(
    () =>
      selectedItem
        ? Object.keys(getStatusCounts(selectedItem)).map((key) => ({
            label: key,
            value: selectedItem.statusCounts[key],
          }))
        : [],
    [selectedItem],
  );

  const itemTabs = items.map((e) => ({
    label: getTypeLabel(e.type),
    value: e.sku,
  }));

  useEffect(() => {
    setSelectedItem(items.find((e) => e.sku === selectedProductTypeTab));
  }, [selectedProductTypeTab]);

  useEffect(() => {
    if (items)
      setSelectedItem(
        selectedProductTypeTab
          ? items.find((e) => e.sku === selectedProductTypeTab)
          : items[0],
      );
  }, [items]);

  const selectedItemTypeLabel = getTypeLabel(selectedItem?.type);

  return (
    <div className={`w-100 w-md-50 ms-0  ${styles['progress-card']}`}>
      <div className={styles['card-container']}>
        <div className="p-3">
          {itemTabs.length > 1 && (
            <div className="mb-4">
              <Tabs
                labels={itemTabs}
                theme="light"
                value={itemTabs.findIndex((e) => e.value === selectedItem.sku)}
                onChange={(evt, value) => {
                  setSelectedItem(
                    items.find((e) => e.sku === itemTabs[value].value),
                  );
                  onBundleProductTabChange(itemTabs[value].value);
                }}
              />
            </div>
          )}

          <h5 className="fw-bold fs-5 mb-0">
            <span className="text-capitalize">{selectedItemTypeLabel}</span>{' '}
            breakdown by status
          </h5>
          <span
            className={`label ${styles['grey-5']}`}
            data-testid="product-enrolled"
          >
            {product.quantityRedeemed.toLocaleString('en-US')} user
            {product.quantityRedeemed > 1 ? 's' : ''}{' '}
            {product.quantityRedeemed > 1 ? 'have' : 'has'} redeemed
          </span>
        </div>
        <BreakdownTable
          data={statusCount}
          type={selectedItemTypeLabel}
          total={product.quantityRedeemed}
          scrollToTable={scrollToTable}
        />
      </div>
    </div>
  );
}
